import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { MsgToastStyled } from "./styled";
import { Icons } from "components";

const MsgToast = ({ theme_success_toast, theme_error_toast, labelTop = "", labelBottom = "" }) => {
  const customClass = cx({
    theme_success_toast: theme_success_toast,
    theme_error_toast: theme_error_toast,
  });

  return (
    <MsgToastStyled>
      <div className={customClass}>
        <div className="g-t-t">
          {theme_error_toast ? <Icons.SaveError /> : <Icons.SaveSuccess />}
          <div className="text_toast">
            {labelTop && <div className='text_top'> {labelTop}</div>}
            {labelBottom && <div className='text_bottom'> {labelBottom}</div>}
          </div>
        </div>
      </div>
    </MsgToastStyled>
  );
};


export default MsgToast;
